<div class="modal-body">
  <p class="p-3 d-flex flex-row justify-content-end">
    <button
      (click)="alsWeggeklicktMarkieren()"
      aria-label="schließen"
      class="close p-2 btn"
      type="button"
    >
      <h3 aria-hidden="true">&times;</h3>
    </button>
  </p>
  <p class="p-3">
    Liebe Fachärztinnen und Fachärzte,<br>
    am vergangenen Montag ist die bundesweite Kampagne <strong>„Versorgen statt Sparen“</strong> unseres Spitzenverbandes Fachärztinnen und Fachärzte Deutschlands e. V. (SpiFa) gestartet.<br>
    Die Kampagne macht gegenüber Patientinnen und Patienten sichtbar, welche Bedeutung eine verlässlich finanzierte ambulante fachärztliche Versorgung für Termine, Behandlungskapazitäten und die wohnortnahe Versorgung hat.<br>
    Hintergrund sind die mit dem GKV-Beitragssatzstabilisierungsgesetz verbundenen Einschnitte in die Finanzierung der fachärztlichen Versorgung.
  </p>
  <p>
    <a href="https://www.versorgen-statt-sparen.de/" target="_blank" (click)="alsGelesenMarkieren()">
      <img src="assets/popups/versorgen-statt-sparen/banner.png" alt="Versorgen statt Sparen" class="img-fluid">
    </a>
  </p>
  <p class="p-3 text-center">
    <a href="https://www.versorgen-statt-sparen.de/" target="_blank" (click)="alsGelesenMarkieren()">
      https://www.versorgen-statt-sparen.de/
    </a>
  </p>
</div>
